import { Pencil, Trash2 } from 'lucide-react';
import type { WantedItem } from '@siliconvault/shared';
import { useTranslation } from '../../i18n';
import styles from './WantedItemCard.module.css';

interface Props {
  item: WantedItem;
  canEdit?: boolean;
  onEdit?: (item: WantedItem) => void;
  onDelete?: (id: string) => void;
}

export function WantedItemCard({ item, canEdit, onEdit, onDelete }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <h3 className={styles.name}>{item.name}</h3>
        {canEdit && (
          <div className={styles.cardActions}>
            <button className={styles.actionBtn} onClick={() => onEdit?.(item)} title={t('community.edit')}>
              <Pencil size={13} strokeWidth={1.75} />
            </button>
            <button className={`${styles.actionBtn} ${styles.actionBtnDanger}`} onClick={() => onDelete?.(item.id)} title={t('community.delete')}>
              <Trash2 size={13} strokeWidth={1.75} />
            </button>
          </div>
        )}
      </div>
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.tagPlatform}`}>{item.platform}</span>
        <span className={`${styles.tag} ${styles.tagCategory}`}>{item.category}</span>
        {item.conditionMin && <span className={`${styles.tag} ${styles.tagCondition}`}>{t('community.minCondition')}: {item.conditionMin}</span>}
      </div>
      {item.description && <p className={styles.description}>{item.description}</p>}
      {!item.isPublic && <span className={`${styles.visibility} ${styles.visibilityPrivate}`}>{t('community.private')}</span>}
    </div>
  );
}
